/* Searchable resource titles and alternate questions. Keep answers in their linked source. */
(() => {
  'use strict';

  const screenModels = ['break-x1', 'break-x2', 'shell-s1', 'shell-s2', 'shell-s3', 'sparkle-k1'];
  const video = (id, name, videoId, keywords, screenOnly = false) => ({
    id,
    name,
    category: 'Video Guide',
    url: '/pages/support-video-guide#video-' + videoId,
    body: 'Official video tutorial: ' + name,
    keywords,
    type: 'video',
    ...(screenOnly ? { models: screenModels.slice() } : {})
  });
  const manual = (model, name, body, keywords) => ({
    id: 'manual-' + model,
    name,
    category: 'Manuals',
    url: '/pages/support-manuals#' + model,
    body,
    keywords,
    type: 'manual',
    models: [model]
  });

  window.IKARAO_SUPPORT_SEARCH_CATALOG = {
    entries: [
      video('video-quick-start', 'How do I start singing with IKARAO?', 'hiWcIQOMcpY',
        'quick start first time beginner unboxing setup start karaoke sing'),
      video('video-hardware', 'Where are the buttons and ports on my IKARAO?', 'ycEsTHpZmH0',
        'hardware controls button port input output socket connector location'),
      video('video-software', 'How do I use the IKARAO touchscreen and software?', '-_vbbt33PGo',
        'touchscreen touch screen display menu interface software navigation settings', true),
      video('video-karafun', 'How do I sing with KaraFun and use the 6-month pass?', 's6rSN3ZnyOc',
        'karafun kara fun activation activate six month six-month 6 month pass included offer membership subscription', true),
      video('video-youtube-karaoke', 'How do I sing karaoke with YouTube?', 'WgRIJ97utzo',
        'youtube you tube karaoke lyrics backing track sing song', true),
      video('video-local-files', 'How do I play karaoke files from USB or a TF card?', 'wQAuEqLtHzc',
        'usb usb stick tf card memory card micro sd microsd local files flash drive thumb drive songs playback'),
      video('video-microphone-setup', 'How do I set up and sync the wireless microphones?', 'pP-wZr_hZn8',
        'microphone mic wireless sync synchronize synchronise pair pairing connect setup'),
      video('video-mobile-apps', 'How do I connect mobile apps to IKARAO?', 'z9DTX_Y1lCo',
        'mobile apps application phone smartphone connect iphone android', true),
      video('video-spotify', 'How do I stream Spotify on IKARAO?', 'dmswzssoSNM',
        'spotify streaming stream music songs listen', true),
      video('video-apple-music', 'How do I stream Apple Music on IKARAO?', 'YSKznkCnxkQ',
        'apple music streaming stream songs listen iphone', true),
      video('video-external-audio-in', 'How do I play audio from an external device?', 'xk4k-08rrVg',
        'external audio input aux line in source cable device music playback'),
      video('video-youtube-video', 'How do I watch YouTube videos on IKARAO?', 'Gaxb8mQ_ZY4',
        'youtube you tube watch video playback', true),
      video('video-tv-projector', 'How do I connect IKARAO to a TV or projector?', 'Famwsupi8GE',
        'hdmi television tv projector external screen display connect connection'),
      video('video-electric-guitar', 'How do I connect and use an electric guitar?', 'XAGSJQEv3Gc',
        'electric guitar instrument input connection plug play'),
      video('video-external-audio-out', 'How do I output IKARAO sound to an external speaker?', 'KTwbbwSLCb8',
        'external speaker audio output aux out line out sound connect connection amplifier'),
      video('video-charging', 'How do I charge the machine and microphones correctly?', '9HN98qWvrPI',
        'charge charging battery microphone mic machine adapter power supply'),
      video('video-dsp-effects', 'How do I adjust microphone DSP sound effects?', 'cO6m-xqvD3M',
        'microphone mic dsp sound effects adjust voice echo reverb'),
      video('video-firmware-update', 'How do I update IKARAO firmware over the air?', 'd1f4j-pIgYg',
        'firmware update upgrade ota over the air system software version', true),
      video('video-volume', 'How do I adjust master, music and microphone volume?', 'aWWLT-FZQJ0',
        'volume loud quiet low music microphone mic master adjust control level speaker silent music silent backing track no music'),

      manual('break-x1', 'IKARAO Break X1 manual',
        'English PDF, 65 pages. Hardware, first steps, settings, playback, troubleshooting, safety and technical specifications.',
        'break x1 x 1 instruction user manual instructions pdf download guide handbook'),
      manual('break-x2', 'IKARAO Break X2 manual',
        'English PDF, 65 pages. Official Break X2 instructions and product-specific reference information.',
        'break x2 x 2 instruction user manual instructions pdf download guide handbook'),
      manual('shell-s1', 'IKARAO Shell S1 manual',
        'English PDF, 58 pages. Product controls, first steps, charging, system settings, playback, connections and safety guidance.',
        'shell s1 s 1 instruction user manual instructions pdf download guide handbook'),
      manual('shell-s2', 'IKARAO Shell S2 manual',
        'English PDF, 60 pages. Product controls, first steps, charging, system settings, playback, connections and safety guidance.',
        'shell s2 s 2 instruction user manual instructions pdf download guide handbook'),
      manual('micbox-pro', 'IKARAO Micbox Pro manual',
        'English PDF, 10 pages. Package contents, first-time use, microphone and receiver controls, rebinding and sanitizing storage.',
        'micbox mic box pro instruction user manual instructions pdf download guide handbook receiver rebind'),
      manual('sparkle-k1', 'IKARAO Sparkle K1 guide and quick-start PDF',
        'Official illustrated online guide and PDF quick-start guide for Sparkle K1.',
        'sparkle k1 k 1 instruction user manual instructions pdf download quick start guide'),
      {
        id: 'product-shell-s3',
        name: 'Shell S3 product support',
        category: 'Product support',
        url: '/pages/support-product?model=shell-s3',
        body: 'Shell S3 product support. A Shell S3 manual is not currently listed in the Manuals center.',
        keywords: 'shell s3 s 3 manual instructions product guide',
        type: 'resource',
        models: ['shell-s3']
      },
      {
        id: 'policy-returns',
        name: 'Return & Exchange Policy',
        category: 'Policies',
        url: '/pages/return-exchange-policy',
        body: 'Read the current official terms for returns, exchanges and refund handling.',
        keywords: 'return policy refund exchange replacement send back money back cancel return window',
        type: 'policy'
      },
      {
        id: 'policy-shipping',
        name: 'Shipping Policy',
        category: 'Policies',
        url: '/pages/shipping-policy',
        body: 'Read the current official terms for destinations, delivery estimates, shipping fees, taxes and carrier exceptions.',
        keywords: 'shipping policy delivery ship destination international country countries cost fee tax customs duty duties',
        type: 'policy'
      },
      {
        id: 'policy-warranty',
        name: 'Limited warranty',
        category: 'Policies',
        url: '/pages/support-policy#warranty',
        body: 'Warranty coverage guidance and the information needed to review the terms that apply to your purchase.',
        keywords: 'warranty guarantee coverage extension extended exclusions purchase protection',
        type: 'policy'
      },
      {
        id: 'policy-care',
        name: 'Care, charging and storage',
        category: 'Policies',
        url: '/pages/support-policy#care',
        body: 'Use the safety, battery, screen and storage instructions for your exact model.',
        keywords: 'care storage store clean cleaning maintenance safety battery screen',
        type: 'policy'
      },
      {
        id: 'policy-privacy',
        name: 'Privacy and account safety',
        category: 'Policies',
        url: '/pages/support-policy#privacy',
        body: 'Find the official privacy policy for your product or website interaction.',
        keywords: 'privacy policy personal data account safety information',
        type: 'policy'
      }
    ],

    branchAliases: {
      'karafun/register': 'karafun create account sign up signup registration register email already exists cannot make account',
      'karafun/login': 'karafun sign in signin log in login cannot access account forgot password reset password recover account',
      'karafun/preview': 'karafun songs stop after 30 seconds thirty seconds short preview sample songs cut off only plays part of song full songs full length cannot play complete song',
      'karafun/offer': 'karafun activate activation pass code redeem free trial six months 6 months included membership subscription paid plan offer missing',
      'power/dead': 'will not turn on wont turn on does not start no power dead machine black screen no response power button',
      'power/notcharging': 'will not charge wont charge not charging battery does not charge charging light indicator plugged in charger',
      'power/unplugged': 'only works plugged in turns off when unplugged battery will not hold charge cannot use without power cable portable battery',
      'power/shutdown': 'shuts down switches off turns off by itself suddenly stops power cuts out overheating hot machine',
      'power/replacement': 'lost charger damaged charger replacement adapter power supply cable charging cord buy charger',
      'apps/update': 'system firmware software update upgrade version ota over the air latest update',
      'apps/download': 'app application will not download cannot install installation failed stuck downloading download error',
      'apps/wifi': 'wifi wi fi wireless internet network cannot connect connection router hotspot offline',
      'sound/speech': 'microphone speech speaking presentation talk without music voice only mic only public address',
      'sound/voice': 'my microphone has no sound mic not working no voice cannot hear voice one microphone silent intermittent microphone cuts out audio missing',
      'sound/charging': 'microphone mic will not charge wont charge charging battery indicator light dock',
      'sound/phone': 'connect phone bluetooth iphone android smartphone play music phone audio pairing bluetooth connection',
      'setup/first': 'first time setup set up quick start beginner start singing unbox getting started use karaoke machine',
      'setup/tv': 'hdmi tv television projector connect connection external screen no picture no signal display lyrics television',
      'setup/choose': 'compare models difference which model choose product identify machine x1 x2 s1 s2 s3',
      'setup/accessories': 'compatible accessories microphone stand speaker stand tripod replacement accessory buy accessories',
      'setup/outdoor': 'outdoor outside waterproof water resistant rain beach garden camping pool',
      'orders/delivery': 'delivery estimate arrive arrival shipping time how long country destination available split separate parcels packages',
      'orders/costs': 'shipping cost charge fee delivery fee taxes tax customs duty duties import',
      'orders/address': 'wrong address correct change delivery shipping address move order address',
      'orders/damage': 'arrived damaged broken missing item wrong item incomplete order missing parts package product damage',
      'orders/tracking': 'where is my order track shipment tracking number carrier delivery status parcel package not arrived',
      'service/warranty': 'warranty guarantee coverage extended extension purchase protection register warranty',
      'service/request': 'contact customer service support email telephone phone number human assistance repair broken product problem',
      'service/exchange': 'exchange replace replacement return defective product swap'
    }
  };
})();
